import { render, staticRenderFns } from "./educationList.vue?vue&type=template&id=425e1905&"
import script from "./educationList.vue?vue&type=script&lang=js&"
export * from "./educationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports